import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

import { Icon, Text } from '@notablehealth/design-system';
import { isDefined } from 'common';

import { SidebarNavigationLink } from './Link';
import { SectionState, useSidebarNavigationRouteSectionsContext } from './sidebarRoutes';
import { EventCategory, useCaptureEvents } from '../../../../utils/events';
import { type RouteSection } from '../../common';
import { SideNavigationState, useSideNavigationModeContext } from '../../context';

interface SidebarNavigationLinkAccordionProps {
  routeSection: RouteSection;
}

export function SidebarNavigationLinkAccordion(props: SidebarNavigationLinkAccordionProps) {
  const { routeSection } = props;
  const { label, links } = routeSection;
  const { sectionExpansionState, setSectionExpansionState, isBestMatchNavigationSection } =
    useSidebarNavigationRouteSectionsContext();
  const { sideNavigationState } = useSideNavigationModeContext();
  const { captureEvent } = useCaptureEvents();
  const isExpanded = sectionExpansionState[label] === SectionState.Open;

  return (
    <Accordion
      expanded={sectionExpansionState[label] === SectionState.Open}
      onChange={(_, nextIsExpanded) => {
        setSectionExpansionState((priorExpansionState) => ({
          ...priorExpansionState,
          [label]: nextIsExpanded ? SectionState.Open : SectionState.Closed,
        }));
      }}
    >
      <AccordionSummary
        sx={{
          backgroundColor:
            isBestMatchNavigationSection(routeSection) && !isExpanded
              ? 'rgba(255, 255, 255, 0.2)'
              : 'transparent',
        }}
        expandIcon={<Icon.ChevronDown color="text.primary" />}
        tabIndex={sideNavigationState === SideNavigationState.Collapsed ? -1 : 0}
      >
        <Text
          variant="paragraph-medium"
          bold={isBestMatchNavigationSection(routeSection) || isExpanded}
        >
          {label}
        </Text>
      </AccordionSummary>
      <AccordionDetails>
        {links.map((link) => {
          const eventAction = link.eventAction;
          return (
            <SidebarNavigationLink
              key={link.label}
              link={link}
              onClick={
                isDefined(eventAction)
                  ? () => {
                      captureEvent({
                        category: EventCategory.SidebarNavigation,
                        action: eventAction,
                      });
                    }
                  : undefined
              }
            />
          );
        })}
      </AccordionDetails>
    </Accordion>
  );
}
